/**
 * Styles for PharmacyList component
 */

import type { SxProps, Theme } from "@mui/material";
import { getScrollbarSx } from "../../../utils/AIPrescription/constants";

export const containerSx: SxProps<Theme> = {
  mt: 2,
};

export const titleSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 0.5,
  color: "#212529",
};

export const captionSx: SxProps<Theme> = {
  display: "block",
  mb: 1,
  color: "#666",
  fontStyle: "italic",
};

export const getScrollBoxSx = (primaryColor: string): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: 1,
  maxHeight: "250px",
  overflowY: "auto",
  pr: 1,
  ...getScrollbarSx(primaryColor, {
    width: "6px",
    trackBackground: "#f1f1f1",
    borderRadius: "10px",
    thumbHover: true,
  }),
});

export const getPharmacyCardSx = (primaryColor: string): SxProps<Theme> => ({
  p: 1.5,
  cursor: "pointer",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: primaryColor,
    backgroundColor: `${primaryColor}08`,
    transform: "translateX(4px)",
    boxShadow: `0 2px 8px ${primaryColor}30`,
  },
});

export const cardInnerBoxSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
};

export const getPharmacyIconSx = (primaryColor: string): SxProps<Theme> => ({
  color: primaryColor,
  fontSize: "18px",
});

export const pharmacyNameSx: SxProps<Theme> = {
  fontWeight: 500,
  color: "#212529",
};

export const pharmacyTextBoxSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
};

export const pharmacyAddressSx: SxProps<Theme> = {
  color: "#666",
  lineHeight: 1.3,
};
